<div class="right-side p-5">
  <h2>Output Report</h2>
  <div class="row section">

    <!-- app.component.html -->
    <div class="mat-app-background basic-container">
      <form [formGroup]="eventReportForm">
        <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
          <mat-tab label="Event Details">

            <div class="row">
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Name of IA</mat-label>
                  <input matInput formControlName="nameOfOrganisation" />
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Ramp Intervention</mat-label>
                  <input matInput formControlName="interventionName" />
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Ramp Component</mat-label>
                  <input matInput formControlName="interestName" />
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Title of training</mat-label>
                  <input matInput formControlName="eventName" />
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Trainer/Anchor company name</mat-label>
                  <input matInput formControlName="trainerCompanyName" />
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Brief content outline of the workshop</mat-label>
                  <textarea matInput formControlName="bWorkshop" rows="2"></textarea>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Planned date</mat-label>
                  <input matInput formControlName="eventDate" />
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Actual start date</mat-label>
                  <input matInput
                         [matDatepicker]="startPicker"
                         formControlName="actualStartDate"
                         (dateChange)="onDateChange($event,'dateOfStart')"
                         [value]="startDateTime | date: 'dd/MM/yyyy'"
                         [min]="actualDate"
                         readonly />
                  <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                  <mat-datepicker #startPicker></mat-datepicker>
                </mat-form-field>
              </div>

              <div class="col-md-4">

                <!--<label for="time">Select Time:</label>
  <input id="time" type="time" [(ngModel)]="timeValue" (change)="onTimeChange($event)" />
  <p>Formatted Time: {{ formattedTime }}</p>-->
                <!--<mat-form-field appearance="outline">
    <mat-label>Select Time:</mat-label>
    <input matInput [ngxMatTimepicker]="apicker" formControlName="actualStartTime" (change)="onTimeChange($event,'startTime')">-->
                <!-- Time picker toggle icon -->
                <!--<mat-icon matSuffix (click)="apicker.open()"></mat-icon>-->
                <!--<ngx-mat-timepicker #apicker></ngx-mat-timepicker>
  </mat-form-field>-->

                <mat-form-field appearance="outline">
                  <mat-label>Select Time:</mat-label>
                  <input matInput
                         [ngxMatTimepicker]="startapicker"
                         formControlName="actualStartTime">
                  <ngx-mat-timepicker-toggle matSuffix [for]="startapicker"></ngx-mat-timepicker-toggle>
                  <ngx-mat-timepicker #startapicker (change)="onTimeChange($event, 'startTime')"></ngx-mat-timepicker>
                </mat-form-field>

              </div>

            </div>

            <div class="row">
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Date of completion</mat-label>
                  <input matInput
                         [matDatepicker]="completionDatePicker"
                         formControlName="dateOfCompletion"
                         (dateChange)="onDateChange($event,'dateOfComp')"
                         [value]="startDateTime | date: 'dd/MM/yyyy'"
                         [min]="DateCompletionTime"
                         readonly />
                  <mat-datepicker-toggle matSuffix [for]="completionDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #completionDatePicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <!--<mat-form-field appearance="outline">
                  <mat-label>Time of completion</mat-label>
                  <input matInput [ngxMatTimepicker]="endpicker" formControlName="timeOfCompletion" (change)="onTimeChange($event,'endTime')">
                  <ngx-mat-timepicker #endpicker></ngx-mat-timepicker>
                </mat-form-field>-->
                <mat-form-field appearance="outline">
                  <mat-label>Select Time:</mat-label>
                  <input matInput
                         [ngxMatTimepicker]="endapicker"
                         formControlName="timeOfCompletion">
                  <ngx-mat-timepicker-toggle matSuffix [for]="endapicker"></ngx-mat-timepicker-toggle>
                  <ngx-mat-timepicker #endapicker (change)="onTimeChange($event, 'endTime')"></ngx-mat-timepicker>
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Duration of workshop</mat-label>
                  <input matInput type="text" formControlName="durationOfWorkshop" />
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Unit</mat-label>
                  <mat-select formControlName="unit">
                    <mat-option *ngFor="let unit of units" [value]="unit">{{ unit }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Trainer’s Mobile number</mat-label>
                  <input matInput formControlName="contactNumber" />
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Trainer’s Email Id</mat-label>
                  <input matInput formControlName="trainerEmailId" />
                </mat-form-field>
              </div>
            </div>

          </mat-tab>

          <!--<mat-tab label="Participant details">
            <div class="row">
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Total no. of participants</mat-label>
                  <input matInput formControlName="totalNoOfParticipants" />
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Total no. of Unique participants</mat-label>
                  <input matInput formControlName="totalNoOfUniqueParticipant" />
                </mat-form-field>
              </div>
              <div class="col-md-4"></div>
            </div>
          </mat-tab>-->

          <mat-tab label="Participant details / Bifurcation">
            <div class="row">
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Total no. of participants</mat-label>
                  <input matInput formControlName="numberOfParticipants" />
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Total no. of Unique participants</mat-label>
                  <input matInput formControlName="numberOfUniqueParticipants" />
                </mat-form-field>
              </div>
              <div class="col-md-4"></div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>No. of women header MSMEs</mat-label>
                  <input matInput formControlName="numberOfWomenParticipants" />
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>No. of SC header MSME</mat-label>
                  <input matInput formControlName="numberOfSC" />
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>No. of ST header MSME </mat-label>
                  <input matInput formControlName="numberOfST" />
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>No. of Micro MSMEs</mat-label>
                  <input matInput formControlName="numberOfMicroEnterprises" />
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>No. of Small MSMEs</mat-label>
                  <input matInput formControlName="numberOfSmallEnterprises" />
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>No. of Medium MSMEs</mat-label>
                  <input matInput formControlName="numberOfMediumEnterprises" />
                </mat-form-field>
              </div>
            </div>
          </mat-tab>

          <mat-tab label="Venue Details">
            <div class="row">
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>District</mat-label>
                  <input matInput formControlName="districtName" />
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Block/Taluka</mat-label>
                  <input matInput formControlName="blockName" />
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Village</mat-label>
                  <input matInput formControlName="village" />
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Address</mat-label>
                  <textarea matInput formControlName="venueDetails" rows="2"></textarea>
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Please select amenities provided to participants</mat-label>
                  <mat-select formControlName="amenities" multiple>
                    <mat-option *ngFor="let amenitie of amenities" [value]="amenitie">{{ amenitie }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <!--<div class="col-md-4">
      <mat-form-field appearance="outline">
        <mat-label>SPOC name</mat-label>
        <input matInput formControlName="spocName" />
      </mat-form-field>
    </div>-->
            </div>
            <!--<div class="row">
    <div class="col-md-4">
      <mat-form-field appearance="outline">
        <mat-label>SPOC Mobile number</mat-label>
        <input matInput formControlName="spocMobile" />
      </mat-form-field>
    </div>
    <div class="col-md-4">
      <mat-form-field appearance="outline">
        <mat-label>Coordinators email id</mat-label>
        <input matInput formControlName="spocEmail" />
      </mat-form-field>
    </div>
    <div class="col-md-4">

    </div>
  </div>-->
            <div class="row">
              <div class="col-md-6">
                <mat-form-field appearance="outline">
                  <mat-label>Highlights of the workshop</mat-label>
                  <textarea matInput formControlName="highlightsWorkshop" rows="2"></textarea>
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field appearance="outline">
                  <mat-label>Handholding services offered to MSME post workshop</mat-label>
                  <textarea matInput formControlName="handholdingWorkshop" rows="2"></textarea>
                </mat-form-field>
              </div>

            </div>

            <hr />
            <table class="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th>SPOC Name</th>
                  <th>SPOC Mobile Number</th>
                  <th>SPOC Email Id</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let spoc of spocList">
                  <td>{{ spoc.spocName }}</td>
                  <td>{{ spoc.spocMobile }}</td>
                  <td>{{ spoc.spocEmail }}</td>
                </tr>
              </tbody>
            </table>

            <div class="row text-center">
              <div class="col-md-12">
                <div [ngClass]="{'d-none': isHidden}">
                  <button type="submit" class="btn btn-secondary mt-1" (click)="onSubmit(false)">Save as Draft</button>
                  <button type="submit" class="btn btn-success mx-1 mt-1" (click)="onSubmit(true)">Submit</button>
                </div>
                <button type="button" class="btn btn-danger mt-1" (click)="onBack()">Back</button>
              </div>
            </div>

            <!--<div class="row text-center" [ngClass]="{'d-none': isHidden}">
    <div class="col-md-12">
      <button type="submit" class="btn btn-secondary" (click)="onSubmit(false)">Save as Draft</button>&nbsp;&nbsp;
      <button type="submit" class="btn btn-success" (click)="onSubmit(true)">Submit</button>&nbsp;&nbsp;
      <button type="button" class="btn btn-danger" (click)="onCancel()">Cancel</button>
    </div>
  </div>-->





          </mat-tab>

          <!--<mat-tab label="Submit">
            <div class="tab-content">
              <button mat-raised-button color="primary" (click)="onSubmit()">Submit</button>
            </div>
          </mat-tab>-->
        </mat-tab-group>
      </form>
    </div>

  </div>
</div>
